import { render, staticRenderFns } from "./VIcon.vue?vue&type=template&id=0a3036c2"
import script from "./VIcon.vue?vue&type=script&lang=ts"
export * from "./VIcon.vue?vue&type=script&lang=ts"
import style0 from "./VIcon.vue?vue&type=style&index=0&id=0a3036c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports